import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { BibliographyClass, CollectionFlag, Prefix } from '@/types'

export interface ReferenceBibliography {
  id: number
  referenceId: number
  bibliographyId: number
  bibliographyClass: BibliographyClass
  prefix: Prefix
  searchType: SystemCode
  memo: string
  materialFormat: string
  class: string
  title: string
  author: string
  publisher: string
  published: string
  collectionFlag: CollectionFlag
  revision: number
}

export function ReferenceBibliographyFromJSON(
  json: any
): ReferenceBibliography {
  return {
    id: exists(json, 'id') ? json.id : 0,
    referenceId: exists(json, 'reference_id') ? json.reference_id : 0,
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Set,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    memo: exists(json, 'memo') ? json.memo : '',
    materialFormat: exists(json, 'display_material_format')
      ? json.display_material_format
      : '',
    class: exists(json, 'display_class') ? json.display_class : '',
    title: exists(json, 'display_title') ? json.display_title : '',
    author: exists(json, 'display_author') ? json.display_author : '',
    publisher: exists(json, 'display_publisher') ? json.display_publisher : '',
    published: exists(json, 'display_published') ? json.display_published : '',
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}

export function ReferenceBibliographyToJSON(
  value?: ReferenceBibliography | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    bibliography_real_id: value.bibliographyId,
    memo: value.memo
  }
}
